export default __webpack_public_path__ + "static/media/consultingfirm1.ff4e1002.jpg";